const RectText = ({
  text,
  bgcolor,
  color,
  opacity,
  fontWeight,
}: {
  text: number | string | null;
  bgcolor?: string;
  color?: string;
  opacity?: number;
  fontWeight?: string;
}) => {
  return (
    <p
      className="d-flex justify-content-center align-items-center       
      border border-primary rounded p-1
      rounded-md"
      style={{
        width: 'fit-content',
        height: '28px',
        backgroundColor:
          bgcolor ?? 'color-mix(in srgb, var(--secondary) 20%, transparent)',
        color: color ?? 'var(--primary)',
        fontWeight: fontWeight ?? 'bold',
        opacity: opacity ?? 0.8,
        margin: '0px',
      }}
    >
      {text ?? 0}%
    </p>
  );
};

export default RectText;
